import { toast } from "react-toastify";
import { ProviderServiceInternal } from "../../services/provider.service";
import { AppointmentServiceInternal } from "../../services/appointment.service";
import moment from "moment-timezone";

export class filterModel {
    search: string = "";
    startDate?: string = "";
    endDate?: string = "";
    inmateDob?: Date | null = null;
    stateSearch?: string = "";
}

export const today = new Date();

export const nextWeek = new Date(today);
nextWeek.setDate(nextWeek.getDate() + 7);

export const phoneNumberFormat = ("(###)-###-####");

export const zipCodeFormat = /^\d{5}(?:[-\s]\d{4})?$/;

export const handleJoinMeeting = async (providerId: number) => {
    const response = await ProviderServiceInternal.getproviderbyuserid(providerId);
    let sessionLink = response.data.data[0].sessionLink;

    if (response?.data.isSuccess) {
        window.open(sessionLink, '_blank');
    }
    else {
        toast.error("getting error while fetching link");
    }
}

export const handleMeeting = async (athenaAppointmentId: number, athenaPatientId: number) => {
    const response = await AppointmentServiceInternal.getTelehealthLink(athenaAppointmentId, athenaPatientId);
    let sessionLink = response.data.data;
    if (response?.data.isSuccess) {
        window.open(sessionLink, '_blank');
    }
    else {
        toast.error(response?.data.message);
    }
}

export const isMeetingButtonEnabled = (appointmentDateTime: Date): boolean => {
    // Get the current date and time
    const currentDate = new Date();
    currentDate.setMinutes(currentDate.getMinutes() + currentDate.getTimezoneOffset()); // convert to UTC
    // Check if the current datetime is before the appointment datetime
    return currentDate >= appointmentDateTime
};


// Converts to Local ITme
export const convertToLocalTime = (timeString: string): string => {
        const facilityMoment = moment.tz(timeString, 'HH:mm', 'UTC');
        const localMoment = facilityMoment.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
        return localMoment.format('hh:mm A z');
}

export const convertToLocalTimeString = (timeString: string): string => {
    const facilityMoment = moment.tz(timeString, 'HH:mm', 'UTC');
    const localMoment = facilityMoment.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
    return localMoment.format('HH:mm');
}